// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b35fdc33","453":"e41d49a6","732":"e6665a9a"}[chunkId] + ".chunk.js";
};